// Тумблер «Косяки» на карте течений: показывать ли вручную отмеченные косяки.
//
// Гасит косяк ЦЕЛИКОМ — и отметку, и её снос (см. schoolsVisibility): косяк
// рисуется двумя слоями, и половинчатое выключение оставило бы на карте ровно
// те косяки, ради которых тумблер и нажимают. Факты вылова он не трогает.
import { HintDot } from '../help/HintDot'
import { useT } from '../i18n'

interface Props {
  enabled: boolean
  onToggle: (on: boolean) => void
}

export function SchoolsControl({ enabled, onToggle }: Props) {
  const t = useT()
  return (
    <div className="eyebrow flex items-center gap-1.5">
      {t('models.schools.title')}
      <HintDot id="schools" />
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label={t('models.schools.toggleAria')}
        onClick={() => onToggle(!enabled)}
        className={
          'relative ml-auto h-4 w-7 rounded-full transition-colors ' +
          (enabled ? 'bg-sonar' : 'bg-hull')
        }
      >
        <span
          className="absolute top-0.5 h-3 w-3 rounded-full bg-white transition-all"
          style={{ left: enabled ? 14 : 2 }}
        />
      </button>
    </div>
  )
}
